import * as React from "react";
const SvgMoonpay = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 865, height: 865, fill: "none", viewBox: "0 0 865 865", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#7715F5", d: "M620.65 329.071a82.51 82.51 0 1 0-76.23-50.933 82.496 82.496 0 0 0 76.23 50.933M367.655 700.674a201.12 201.12 0 0 1-185.809-124.153 201.113 201.113 0 0 1 146.573-274.218 201.118 201.118 0 1 1 39.236 398.371" }));
export default SvgMoonpay;
